import React, { useContext } from 'react';
import classnames from 'classnames';
import { connectStateResults } from 'react-instantsearch-dom';
import { useUpdateEffect } from 'react-use';
import { Tabs, Tab, Icon, Typography } from 'ck-ui';
import { getPriceString } from 'ck-utils/price';
import { BundleLookPageContext, ProductListingPageContext } from '../context';
import styles from './BYOTabs.module.scss';

const BYOTabs = connectStateResults(({ isSearchStalled }) => {
  const { groups, selectedTag, onChangeTag, bundle } = useContext(BundleLookPageContext);
  const { isMobile } = useContext(ProductListingPageContext);
  const variant = isMobile ? 'heading8' : 'heading6';

  // Move to the next tab that hasn't been fulfilled
  useUpdateEffect(() => {
    const currentUnfulfilledGroup = groups.find(group => group.tag === selectedTag && group.selectedCount < group.groupCount);
    if (currentUnfulfilledGroup) return;
    const nextUnfulfilledGroup = groups.find(group => group.selectedCount < group.groupCount);
    if (nextUnfulfilledGroup) onChangeTag(nextUnfulfilledGroup.tag);
  }, groups);

  return (
    <div className={styles.root}>
      <Typography
        variant="heading6"
        color="white"
        align="centered"
        className={styles.title}
      >
        {bundle.price ? `BUILD YOUR ${getPriceString(bundle.price)} BUNDLE` : 'BUILD YOUR BUNDLE'}
      </Typography>
      <Tabs
        className={styles.tabs}
        value={selectedTag}
        onChange={(e, value) => {
          onChangeTag(value);
        }}
      >
        {groups.map(group => (
          <Tab
            key={group.tag}
            value={group.tag}
            success={group.selectedCount === group.groupCount}
          >
            <span
              className={classnames(styles.tab, 'is-flex-centered', {
                loading: isSearchStalled && selectedTag === group.tag
              })}
            >
              <Icon name={group.icon} size="medium" className={classnames(styles.icon, 'is-hidden-mobile')} />
              <Typography color="color-inherit" variant={variant}>{group.name}</Typography>
              <Typography color="color-inherit" variant={variant} className={styles.number}>
                ({group.selectedCount}/{group.groupCount})
              </Typography>
            </span>
          </Tab>
        )
        )};
      </Tabs>
    </div>
  );
});

export { BYOTabs };
